export const nullPropsToUndefined = (props: Record<any, any>) => {
  const propsCopy = { ...props }

  Object.keys(propsCopy).forEach((key) => {
    if (propsCopy[key] === null) propsCopy[key] = undefined
  })

  return propsCopy
}
